import { defineMessages } from '@jutro/locale';

export default defineMessages({
    quote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Homeowners Insurance Quote',
        defaultMessage: 'Quote'
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Location',
        defaultMessage: 'Location'
    }
});
